
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

import { FuseNavigationModule } from "@fuse/components";
import { FuseSharedModule } from "@fuse/shared.module";

import { NavbarVerticalStyle1Component } from "app/layout/components/navbar/vertical/style-1/style-1.component";
import { PoweredbyLogoModule } from "app/layout/components/poweredby-logo/poweredby-logo.module";
import { HelpSectionModule } from 'app/layout/components/help-section/help-section.module';

@NgModule({
    declarations: [NavbarVerticalStyle1Component],
    imports: [MatButtonModule, MatIconModule, FuseSharedModule, FuseNavigationModule, PoweredbyLogoModule, HelpSectionModule],
    exports: [NavbarVerticalStyle1Component]
})
export class NavbarVerticalStyle1Module {}
